import { useCallback, useEffect, useRef } from 'react';
export default function useMountedState() {
    var mountedRef = useRef(false);
    var get = useCallback(function () { return mountedRef.current; }, []);
    useEffect(function () {
        mountedRef.current = true;
        return function () {
            mountedRef.current = false;
        };
    });
    return get;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/useMountedState.js
// module id = ./node_modules/react-use/esm/useMountedState.js
// module chunks = main